var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row content-box full-height"},[_c('woot-wizard',{staticClass:"small-3 columns",attrs:{"items":_vm.items}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }